<template>
  <div class="page-main">
    <e-tabs v-if="isLoadTab" :list="statusList" :activeVal.sync="bill_status1" />

    <div class="flex w-100">
      <b-filter-left
        ref="refLeftFilter"
        :init_filter_data="init_filter_data"
        :search_data="search_data"
        @success="updateLeftFilter"
      />
      <div class="flex-1 w-0">
        <div class="flex flex-y-center flex-x-between m-b-10">
          <div class="flex flex-y-center">
            <el-button type="success" size="mini" icon="el-icon-plus" @click="itemDo()"
              >新增订单
            </el-button>
            <el-form class="flex flex-y-center m-l-10" @submit.native.prevent="resetLeftFilter">
              <span>销售日期:</span>
              <e-date-picker
                type="daterange"
                :value.sync="bill_date"
                isShowFast
                @change="resetLeftFilter"
              />
            </el-form>
          </div>
        </div>
        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          :show-footer="!!tableData.length"
          :loading="loading"
          :columns="tableColumn"
          :data="tableData"
          :height="this.$util.getViewHeight() - 36 - 184"
          :footer-method="footerMethod"
          :cell-class-name="cellClassName"
          @cell-dblclick="itemDbDo"
          @resizable-change="handleColumnResize"
        >
          <!-- slot_default -->
          <!-- resultStart -->
          <template #default_bill_code="{ row }">
            <el-link type="primary" @click="itemDo(row.bill_id)">
              {{ row.bill_code }}
            </el-link>
          </template>
          <template #default_zhi_zao_ming_xi="{ row }">
            <el-link type="primary" @click="itemMadeDetail(row.bill_id)">
              <div class="flex flex-y-center">
                <span class="iconfont icon-dingdan f-s-12"></span>
                <span>制造明细</span>
              </div>
            </el-link>
          </template>
          <template #default_zhi_zao_liu_cheng="{ row }">
            <el-link type="primary" @click="itemMadeView(row.bill_id)">
              <div class="flex flex-y-center">
                <span class="iconfont icon-ziliucheng f-s-12"></span>
                <span class="m-l-2">制造流程</span>
              </div>
            </el-link>
          </template>
          <template #default_jiao_huo_ri_qi="{ row }">
            <div>{{ row.jiao_huo_ri_qi || '-' }}</div>
            <div class="c-orange">{{ row.jiao_huo_ri_qi_str }}</div>
          </template>
          <template #default_company_name="{ row }">
            <el-link type="primary" @click="customerFollowUpDetail(row.company_id)">{{
              row.company_name
            }}</el-link>
          </template>
          <template #default_list_chan_pin_tu="{ row }">
            <e-upload-image
              v-if="row.list_chan_pin_tu"
              :list.sync="row.list_chan_pin_tu"
              disabled
            />
          </template>

          <!-- resultOrderYes -->
          <template #default_profit_rate="{ row }"> {{ row.profit_rate }}% </template>

          <!-- resultOrderNo -->
          <template #default_list_gong_cheng_tu="{ row }">
            <e-upload-image
              v-if="row.list_gong_cheng_tu"
              :list.sync="row.list_gong_cheng_tu"
              disabled
            />
          </template>
          <template #default_list_yuan_wen_jian="{ row }">
            <e-upload-file
              v-if="row.list_yuan_wen_jian"
              :list.sync="row.list_yuan_wen_jian"
              disabled
            />
          </template>
          <template #default_list_jian_ce_mu_ban="{ row }">
            <e-upload-file
              v-if="row.list_jian_ce_mu_ban"
              :list.sync="row.list_jian_ce_mu_ban"
              disabled
            />
          </template>
          <template #default_list_jian_ce_bao_gao="{ row }">
            <e-upload-file
              v-if="row.list_jian_ce_bao_gao"
              :list.sync="row.list_jian_ce_bao_gao"
              disabled
            />
          </template>
          <template #default_jin_du="{ row }">
            <div class="flex flex-center">
              <div
                class="flex flex-y-center"
                v-for="(item, index) in diffSearchTypeShowData.list"
                :key="index"
              >
                <span v-if="index">-</span>
                <el-link v-if="row.jin_du === index" type="primary">{{ item }}</el-link>
                <el-link v-if="row.jin_du > index" type="success">{{ item }}</el-link>
                <el-link v-if="row.jin_du < index" type="danger">{{ item }}</el-link>
              </div>
            </div>
          </template>

          <!-- resultEnd -->
          <template #default_operate="{ row }">
            <el-dropdown>
              <el-button type="default" size="mini">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="row.isYinYong" @click.native="itemCopy(row)">
                  <span class="c-green">引用新增</span>
                </el-dropdown-item>
                <el-dropdown-item v-if="row.isChuangJian" @click.native="itemCheHui(row)">
                  <span>撤回提交</span>
                </el-dropdown-item>
                <el-dropdown-item v-if="row.isFuZe" @click.native="itemPass(row)">
                  <span class="c-green">通过</span>
                </el-dropdown-item>
                <el-dropdown-item v-if="row.isFuZe" @click.native="itemReject(row)">
                  <span class="c-red">驳回</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="row.isChuangJian"
                  @click.native="itemPrintQuote(row.bill_id)"
                >
                  打印报价单
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="row.isChuangJian"
                  @click.native="itemPrintVerify(row.bill_id)"
                >
                  打印核算单
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="row.isChuangJian"
                  @click.native="itemPrintOrder(row.bill_id)"
                >
                  打印生产订单
                </el-dropdown-item>
                <el-dropdown-item @click.native="itemPrintLiucheng(row)">
                  打印制造流程
                </el-dropdown-item>
                <el-dropdown-item v-if="row.isChuangJian" @click.native="itemPush(row.bill_id)">
                  <span class="c-blue">继续生成合同</span>
                </el-dropdown-item>
                <el-dropdown-item v-if="row.isChuangJian" @click.native="itemSk(row)">
                  开具收款单
                </el-dropdown-item>
                <el-dropdown-item v-if="row.isChuangJian" @click.native="itemBx(row.bill_id)">
                  开具报销单
                </el-dropdown-item>
                <el-dropdown-item v-if="row.isChuangJian" @click.native="itemSh(row.bill_id)">
                  开具送货单
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="row.isChuangJian || row.isFuZe"
                  @click.native="itemWanJie(row)"
                >
                  <span class="c-blue">完结订单</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="row.isChuangJian || row.isFuZe"
                  @click.native="itemZuoFei(row)"
                >
                  <span class="c-red">订单作废</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="row.isChuangJian || row.isFuZe"
                  @click.native="itemDelete(row)"
                >
                  <span class="c-red">删除</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <!-- slot_pager -->
          <template #pager>
            <div></div>
            <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
    </div>

    <!-- 弹窗-新增核算单 -->
    <PopupCopySuccess
      v-if="isShowPopupCopySuccess"
      :show.sync="isShowPopupCopySuccess"
      :code="activeBillCode"
    />

    <!-- 弹窗-新增核算单 -->
    <PopupVerifyDo
      v-if="isShowPopupVerifyDo"
      :show.sync="isShowPopupVerifyDo"
      :isSourceHeTong="isSourceHeTong"
      :billId="activeBillId"
      @success="updatePage"
    />

    <!-- 弹窗-制造明细 -->
    <b-popup-verify-goods-detail
      v-if="isShowPopupVerifyGoodsDetail"
      :show.sync="isShowPopupVerifyGoodsDetail"
      :id="activeBillId"
    />

    <!-- 弹窗-制造流程 -->
    <b-popup-verify-goods-view
      v-if="isShowPopupVerifyGoodsView"
      :show.sync="isShowPopupVerifyGoodsView"
      :id="activeBillId"
    />

    <!-- 弹窗-开具收款单 -->
    <PopupOpenShouKuan
      v-if="isShowPopupOpenShouKuan"
      :show.sync="isShowPopupOpenShouKuan"
      :companyName="activeCompanyName"
      :billId="activeBillId"
      @success="searchListData"
    />

    <!-- 弹窗-开具报销单 -->
    <PopupOpenBaoXiao
      v-if="isShowPopupOpenBaoXiao"
      :show.sync="isShowPopupOpenBaoXiao"
      :billId="activeBillId"
      @success="searchListData"
    />

    <!-- 弹窗-采购申请 -->
    <PopupApplyPurchase
      v-if="isShowPopupApplyPurchase"
      :show.sync="isShowPopupApplyPurchase"
      :billId="activeBillId"
      @success="searchListData"
    />

    <!-- 弹窗-采购申请-批量 -->
    <PopupSongHuo
      v-if="isShowPopupSongHuo"
      :show.sync="isShowPopupSongHuo"
      :billId="activeBillId"
      @success="searchListData"
    />

    <!-- 弹窗-跟进记录 -->
    <b-popup-customer-follow-up-detail
      v-if="isShowPopupCustomerFollowUpDetail"
      :show.sync="isShowPopupCustomerFollowUpDetail"
      :id="activeId"
    />
  </div>
</template>

<script>
export default {
  tableName: 'new_order_page_list',
  components: {
    PopupCopySuccess: () => import('../common/popup-copy-success'),
    PopupVerifyDo: () => import('../../verify/common/popup-verify-do'),
    PopupOpenShouKuan: () => import('../../verify/common/popup-open-shou-kuan'),
    PopupOpenBaoXiao: () => import('../../verify/common/popup-open-bao-xiao'),
    PopupApplyPurchase: () => import('../../verify/common/popup-apply-purchase'),
    PopupSongHuo: () => import('../../delivery/common/popup-do')
  },
  data() {
    return {
      // loading
      loading: true,
      isLoadTab: false,

      // filter
      bill_date: [this.$util.getDate().monthStart, this.$util.getDate().monthEnd],
      sortData: {
        bill_id: 'desc'
      },
      bill_status1: '全部',
      init_filter_data: {
        active_parent_key: '全部订单',
        active_search_type: '单据',
        hide_count_keys: [],
        api_url_parent: '/admin/gcvip/checkBill2/leftFatherFilter3',
        api_url_child: '/admin/gcvip/checkBill2/leftFilter3'
      },
      left_filter_data: {
        search_type: '单据',
        list: []
      },

      // table
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        dai_shen_he_count: '',
        jin_xing_zhong_count: '',
        yi_wan_jie_count: '',
        yi_zuo_fei_count: ''
      },

      // popup
      isShowPopupCopySuccess: false,
      isShowPopupVerifyDo: false,
      isShowPopupVerifyGoodsDetail: false,
      isShowPopupVerifyGoodsView: false,
      isShowPopupOpenShouKuan: false,
      isShowPopupOpenBaoXiao: false,
      isShowPopupApplyPurchase: false,
      isShowPopupSongHuo: false,
      isShowPopupCustomerFollowUpDetail: false,
      isSourceHeTong: false,
      activeBillId: null,
      activeBillCode: null,
      activeCompanyName: '',
      activeId: null
    }
  },
  computed: {
    // 搜索参数
    search_data() {
      let result = {
        bill_status1: this.bill_status1 === '全部' ? '订单' : this.bill_status1,
        bill_date: this.bill_date || []
      }
      return result
    },
    // 是否是管理员
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    // 当前登录账号id
    accountId() {
      return this.$store.state.loginAccount.id
    },
    // 状态列表
    statusList() {
      let result = [
        {
          key: '全部',
          val: '全部',
          type: 'info'
        },
        {
          key: '待审核',
          val: '待审核',
          count: this.totalObj.dai_shen_he_count,
          type: 'warning',
          isRed: true
        },
        {
          key: '进行中',
          val: '进行中',
          count: this.totalObj.jin_xing_zhong_count,
          type: 'primary'
        },
        {
          key: '已完结',
          val: '已完结',
          count: this.totalObj.yi_wan_jie_count,
          type: 'success'
        },
        {
          key: '已作废',
          val: '已作废',
          count: this.totalObj.yi_zuo_fei_count,
          type: 'info'
        }
      ]
      return result
    },
    // 左侧筛选最后是否选中商品
    isLeftLastChooseGoods() {
      let { search_type, list } = this.left_filter_data
      let len = list.length
      let result = search_type === '单据' && len && list[len - 1].field === 'name' // 确保选中的是单据的商品
      return !!result
    },
    // 不同搜索类型的显示的数据
    diffSearchTypeShowData() {
      let result = {}
      if (this.left_filter_data.search_type === '单据' && this.isLeftLastChooseGoods) {
        result = {
          type: '商品',
          list: []
        }
      }
      if (this.left_filter_data.search_type === '单据' && !this.isLeftLastChooseGoods) {
        result = {
          type: '商品',
          list: ['待执行', '执行中', '已完成']
        }
      }
      if (this.left_filter_data.search_type === '原料') {
        result = {
          type: '原料',
          list: ['待采购', '采购中', '已入库']
        }
      }
      if (this.left_filter_data.search_type === '加工') {
        result = {
          type: '工艺',
          list: ['待加工', '加工中', '已完成']
        }
      }
      if (this.left_filter_data.search_type === '费用') {
        result = {
          type: '费用',
          list: ['待执行', '执行中', '已完成']
        }
      }
      return result
    },
    // 表格列
    tableColumn() {
      let resultStart = [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          fixed: 'left',
          title: '销售单号',
          field: 'bill_code',
          slots: { default: 'default_bill_code' }
        },
        {
          title: '制造明细',
          field: 'zhi_zao_ming_xi',
          slots: { default: 'default_zhi_zao_ming_xi' }
        },
        {
          title: '制造流程',
          field: 'zhi_zao_liu_cheng',
          slots: { default: 'default_zhi_zao_liu_cheng' }
        },
        {
          title: '订单类型',
          field: 'ding_dan_lei_xing'
        },
        {
          title: '销售日期',
          field: 'bill_date'
        },
        {
          title: '业务员',
          field: 'saler_name'
        },
        {
          title: '客户名称',
          field: 'company_name',
          width: 180,
          slots: { default: 'default_company_name' }
        },
        {
          title: '客户编号',
          field: 'company_id',
          width: 80
        },
        {
          title: '交货日期',
          field: 'jiao_huo_ri_qi',
          slots: { default: 'default_jiao_huo_ri_qi' }
        },
        {
          title: `${this.diffSearchTypeShowData.type}图片`,
          field: 'list_chan_pin_tu',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: `${this.diffSearchTypeShowData.type}名称`,
          field: 'name',
          width: 120
        },
        {
          title: '规格(mm)',
          field: 'spec',
          width: 120
        },
        {
          title: '单位',
          field: 'unit',
          width: 60
        },
        {
          title: '数量',
          field: 'counts'
        },
        {
          title: '单价(元)',
          field: 'goods_price'
        },
        {
          title: '金额(元)',
          field: 'goods_amount'
        }
      ]
      let resultOrderYes = [
        {
          title: '销售单价(元)',
          field: 'sales_price'
        },
        {
          title: '销售金额(元)',
          field: 'sales_amount'
        },
        {
          title: '每件利润(元)',
          field: 'profit_row_unit',
          width: 120
        },
        {
          title: '合计利润(元)',
          field: 'profit_row'
        },
        {
          title: '利润率',
          field: 'profit_rate',
          slots: { default: 'default_profit_rate' }
        }
      ]
      let resultOrderNo = [
        {
          title: '工程图',
          field: 'list_gong_cheng_tu',
          slots: { default: 'default_list_gong_cheng_tu' },
          width: 63
        },
        {
          title: '源文件',
          field: 'list_yuan_wen_jian',
          slots: { default: 'default_list_yuan_wen_jian' }
        },
        {
          title: '检测模板',
          field: 'list_jian_ce_mu_ban',
          slots: { default: 'default_list_jian_ce_mu_ban' }
        },
        {
          title: '检测报告',
          field: 'list_jian_ce_bao_gao',
          slots: { default: 'default_list_jian_ce_bao_gao' }
        },
        {
          title: '进度',
          field: 'jin_du',
          slots: { default: 'default_jin_du' },
          width: 132
        }
      ]
      let isLastChooseOrder =
        this.left_filter_data.search_type === '单据' && !this.isLeftLastChooseGoods
      let resultCenter = isLastChooseOrder ? resultOrderYes : resultOrderNo
      let resultEnd = [
        {
          title: '备注',
          field: 'remark',
          width: 120
        },
        {
          title: '项目名称',
          field: 'xiang_mu_ming_cheng',
          width: 120
        },
        {
          title: '单据备注',
          field: 'bill_remark',
          width: 120
        },
        {
          title: '开单公司',
          field: 'saler_company_name',
          width: 180
        },
        {
          fixed: 'right',
          title: '操作',
          field: 'operate',
          slots: { default: 'default_operate' },
          width: 73
        }
      ]
      let result = [...resultStart, ...resultCenter, ...resultEnd]
      this.$util.initTableColumnWidth(this.$options.tableName, result)
      return result
    }
  },
  watch: {
    bill_status1() {
      this.searchListData()
    }
  },
  mounted() {
    this.isLoadTab = false
    if (this.$route.query.status) {
      this.bill_status1 = this.$route.query.status
    }
    this.isLoadTab = true
  },
  methods: {
    // 列宽变化，保存单列宽度
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    // 更新页面
    updatePage() {
      this.$refs.refLeftFilter.updateFilterGroupData()
      this.searchListData()
    },
    // 重置左侧筛选
    resetLeftFilter() {
      if (!this.left_filter_data.list.length) {
        let result = {
          search_type: this.init_filter_data.active_search_type,
          list: []
        }
        this.updateLeftFilter(result)
      }
    },
    // 更新左侧筛选
    updateLeftFilter(val) {
      this.left_filter_data = this.$util.deepCopy(val)
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      let params = {
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        bill_status1: this.search_data.bill_status1,
        bill_date: this.search_data.bill_date,
        sortData: this.$util.deepCopy(this.sortData)
      }
      if (this.left_filter_data.list.length) params.left_filter = this.left_filter_data.list

      let url = ''
      if (this.left_filter_data.search_type === '单据')
        url = '/admin/gcvip/checkBill2/list3ShangPin'
      if (this.left_filter_data.search_type === '原料')
        url = '/admin/gcvip/checkBill2/list3YuanLiao'
      if (this.left_filter_data.search_type === '加工') url = '/admin/gcvip/checkBill2/list3JiaGong'
      if (this.left_filter_data.search_type === '费用')
        url = '/admin/gcvip/checkBill2/list3QiTaFeiYong'

      this.$api({
        method: 'post',
        url,
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            let list = this.$util.deepCopy(data.list)
            list.forEach((item) => {
              item.isYinYong = this.isAdmin || item.saler_id === this.accountId
              item.isChuangJian = this.isAdmin || item.saler_id === this.accountId
              item.isFuZe = this.isAdmin || item.fu_ze_ren_id === this.accountId
            })
            this.tableData = list

            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber

            this.totalObj.dai_shen_he_count = res.data.dai_shen_he_count
            this.totalObj.jin_xing_zhong_count = res.data.jin_xing_zhong_count
            this.totalObj.yi_wan_jie_count = res.data.yi_wan_jie_count
            this.totalObj.yi_zuo_fei_count = res.data.yi_zuo_fei_count
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          let counts = this.$tool.listAddTotal(data, 'counts')
          let goods_amount = this.$tool.listAddTotal(data, 'goods_amount')
          let sales_amount = this.$tool.listAddTotal(data, 'sales_amount')
          let profit_row_unit = this.$tool.listAddTotal(data, 'profit_row_unit')
          let profit_row = this.$tool.listAddTotal(data, 'profit_row')
          let profit_rate = this.$tool.listAddTotal(data, 'profit_rate') / data.length
          let profit_rate_avg = this.$util.getPoint(profit_rate, 'down', 2)
          if (columnIndex === 0) return '合计'
          if (column.field === 'counts') return counts
          if (column.field === 'goods_amount') return goods_amount
          if (column.field === 'sales_amount') return sales_amount
          if (column.field === 'profit_row_unit') return profit_row_unit
          if (column.field === 'profit_row') return profit_row
          if (column.field === 'profit_rate') return `${profit_rate_avg}%`
        })
      ]
    },
    // 行类名计算，实现按字段分组的斑马纹效果
    cellClassName(rowData) {
      let result = this.$tool.getTableCellClassName(this.tableData, rowData, 'bill_id')
      return result
    },

    // 项-制造明细
    itemMadeDetail(id) {
      this.activeBillId = id
      this.isShowPopupVerifyGoodsDetail = true
    },
    // 项-制造流程
    itemMadeView(id) {
      this.activeBillId = id
      this.isShowPopupVerifyGoodsView = true
    },
    // 项-增改
    itemDo(id = null) {
      this.activeBillId = id
      this.isSourceHeTong = !this.activeBillId
      this.isShowPopupVerifyDo = true
    },
    // 项-双击增改
    itemDbDo(val) {
      this.itemDo(val.row.bill_id)
    },
    // 项-引用新增
    itemCopy(row) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/copy',
        params: {
          id: row.bill_id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.activeBillCode = row.bill_code
            this.isShowPopupCopySuccess = true
          }
        })
        .catch(() => {})
    },
    // 项-撤回
    itemCheHui(row) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/salerCheHuiAudit',
        params: {
          id: row.bill_id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('订单已撤回')
          this.getListData()
        }
      })
    },
    // 项-通过
    itemPass(row) {
      this.$confirm(`销售单号:${row.bill_code}，该核算单是否通过审核?`, '提示')
        .then(() => {
          this.itemPassConfirm(row.bill_id)
        })
        .catch(() => {})
    },
    // 项-通过-确认
    itemPassConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/leaderDoAudit',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已通过审核')
          this.getListData()
        }
      })
    },
    // 项-驳回
    itemReject(row) {
      this.$confirm(`销售单号:${row.bill_code}，该核算单是否驳回审核?`, '提示')
        .then(() => {
          this.itemRejectConfirm(row.bill_id)
        })
        .catch(() => {})
    },
    // 项-驳回-确认
    itemRejectConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/leaderReject',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已驳回审核')
          this.getListData()
        }
      })
    },
    // 项-打印报价单
    itemPrintQuote(id) {
      window.open(`/new/verify/print/quote?id=${id}`, '_blank')
    },
    // 项-打印核算单
    itemPrintVerify(bill_id) {
      window.open(`/new/verify/print/verify?id=${bill_id}`, '_blank')
    },
    // 项-打印生产订单
    itemPrintOrder(id) {
      window.open(`/new/verify/print/order?id=${id}`, '_blank')
    },
    // 项-打印制造流程
    itemPrintLiucheng(row) {
      let url = `/new/verify/print/liucheng?billId=${row.bill_id}&goodsId=${row.id}`
      window.open(url, '_blank')
    },
    // 项-生成合同
    itemPush(id) {
      this.isSourceHeTong = true
      this.activeBillId = id
      this.isShowPopupVerifyDo = true
    },
    // 项-开具收款单
    itemSk(row) {
      this.activeCompanyName = row.company_name
      this.activeBillId = row.bill_id
      this.isShowPopupOpenShouKuan = true
    },
    // 项-开具报销单
    itemBx(id) {
      this.activeBillId = id
      this.isShowPopupOpenBaoXiao = true
    },
    // 项-开具送货单
    itemSh(id) {
      this.isShowPopupSongHuo = true
      this.activeBillId = id
    },
    // 项-完结
    itemWanJie(row) {
      this.$confirm(`销售单号:${row.bill_code}，该核算单是否完结?`, '提示')
        .then(() => {
          this.itemWanJieConfirm(row.bill_id)
        })
        .catch(() => {})
    },
    // 项-完结-确认
    itemWanJieConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/wanJie',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('订单已完结')
          this.getListData()
        }
      })
    },
    // 项-作废
    itemZuoFei(row) {
      this.$confirm(`销售单号:${row.bill_code}，该核算单是否作废?`, '提示')
        .then(() => {
          this.itemZuoFeiConfirm(row.bill_id)
        })
        .catch(() => {})
    },
    // 项-作废-确认
    itemZuoFeiConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/zuoFei',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('订单已作废')
          this.getListData()
        }
      })
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm(`销售单号：${row.bill_code}，是否删除该订单?`, '提示')
        .then(() => {
          this.itemDeleteConfirm(row.bill_id)
        })
        .catch(() => {})
    },
    // 项-删除-确认
    itemDeleteConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/doDelete',
        params: {
          id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success(res.data.msg)
            this.getListData()
          }
        })
        .catch(() => {})
    },
    // 客户跟进-详情
    customerFollowUpDetail(id) {
      this.activeId = id
      this.isShowPopupCustomerFollowUpDetail = true
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
